"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.PortraitTextSmall = exports.PortraitText = exports.PortraitImageContent = exports.PortraitName = exports.PortraitImageContainer = exports.PortraitImage = exports.PortraitContent = exports.PortraitLinkWrapper = exports.PortraitContainer = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Media = _interopRequireDefault(require("../Media"));

var _mediaQueries = _interopRequireDefault(require("../../styles/mediaQueries"));

var _Card = _interopRequireDefault(require("../Cards/Card/Card"));

var PortraitContainer = (0, _styled.default)('div')(function () {
  return {
    display: 'flex',
    height: '100%',
    flexDirection: 'column'
  };
});
exports.PortraitContainer = PortraitContainer;
var PortraitLinkWrapper = (0, _styled.default)(_Card.default)(function () {
  return {
    height: 'auto'
  };
});
exports.PortraitLinkWrapper = PortraitLinkWrapper;
var PortraitContent = (0, _styled.default)('div')(function (_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      portrait = _ref$theme.portrait,
      space = _ref$theme.space;
  return _defineProperty({
    background: colors[portrait.background],
    borderRadius: "0 0 ".concat(portrait.borderRadius, " ").concat(portrait.borderRadius),
    flex: 1,
    padding: "".concat(space.small, " ").concat(space.base),
    marginBottom: space.base,

    /* Microsoft IE10 and above - in flex containers you need to set the height for IE explicitly
    not ideal but in the spirit of progressive enhancement  */
    '@media all and (-ms-high-contrast: none)': {
      minHeight: '10.8rem',
      height: '10.8rem'
    }
  }, _mediaQueries.default.medium, {
    marginBottom: space.large
  });
});
exports.PortraitContent = PortraitContent;
var PortraitImage = (0, _styled.default)(_Media.default)(function () {
  return {
    position: 'relative',
    height: 'auto',
    paddingBottom: '100%',
    width: '100%',
    display: 'block'
  };
});
exports.PortraitImage = PortraitImage;
var PortraitImageContainer = (0, _styled.default)('div')(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      portrait = _ref3$theme.portrait,
      colors = _ref3$theme.colors;
  return {
    display: 'flex',
    position: 'relative',
    background: colors[portrait.background],
    borderRadius: portrait.background === 'none' ? portrait.borderRadius : "".concat(portrait.borderRadius, " ").concat(portrait.borderRadius, " 0 0"),
    overflow: 'hidden',
    zIndex: 0,

    /* Microsoft IE10 and above */
    '@media all and (-ms-high-contrast: none)': {
      display: 'block'
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      zIndex: 2,
      height: '50%',
      width: '100%',
      backgroundImage: "linear-gradient(to bottom, transparent 0%, ".concat(portrait.gradientColor, " 100%)"),
      opacity: '0.8'
    }
  };
});
exports.PortraitImageContainer = PortraitImageContainer;
var PortraitName = (0, _styled.default)('h3')(function (_ref4) {
  var _ref4$theme = _ref4.theme,
      fonts = _ref4$theme.fonts,
      portrait = _ref4$theme.portrait,
      textStyles = _ref4$theme.textStyles;
  return _objectSpread(_objectSpread(_objectSpread({
    fontFamily: fonts[portrait.name.fontFamily]
  }, textStyles.headingText.tertiary.mobile), portrait.name.styles), {}, {
    margin: 0
  });
});
exports.PortraitName = PortraitName;
var PortraitImageContent = (0, _styled.default)('div')(function (_ref5) {
  var _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      space = _ref5$theme.space;
  return {
    position: 'absolute',
    color: colors.white,
    zIndex: 3,
    bottom: 0,
    padding: space.base,
    fontWeight: 'normal'
  };
});
exports.PortraitImageContent = PortraitImageContent;
var PortraitText = (0, _styled.default)('p')(function (_ref6) {
  var _ref6$theme = _ref6.theme,
      colors = _ref6$theme.colors,
      space = _ref6$theme.space,
      portrait = _ref6$theme.portrait,
      textStyles = _ref6$theme.textStyles;
  return _objectSpread(_objectSpread({}, textStyles.globalText.desktop), {}, {
    color: colors[portrait.textColor],
    marginBottom: space.xsmall
  });
});
exports.PortraitText = PortraitText;
var PortraitTextSmall = (0, _styled.default)('p')(function (_ref7) {
  var _ref7$theme = _ref7.theme,
      colors = _ref7$theme.colors,
      fonts = _ref7$theme.fonts,
      portrait = _ref7$theme.portrait,
      textStyles = _ref7$theme.textStyles;
  return _objectSpread(_objectSpread(_objectSpread({
    fontFamily: fonts[portrait.textSmall.fontFamily]
  }, textStyles.globalText.mobile), portrait.textSmall.styles), {}, {
    color: colors[portrait.accentColor]
  });
});
exports.PortraitTextSmall = PortraitTextSmall;